import React from 'react';
import { Outlet } from 'react-router-dom';

const AttendanceParentPage = () => {
    return (
        <div style={{ height: 'calc(100vh - 120px)', overflow: 'auto' }}>
            <Outlet />
        </div>
    );
};

export default AttendanceParentPage;